import { useState } from "react";
import MarkdownEntry from "../datatypeComponents/MarkdownEntry";
import { Button } from "semantic-ui-react";

const GroupCriteriaStarter = ({ setGroupCharacteristicState }) => {
    const [criteriaListState, setCriteriaListState] = useState({
        markdown: "Inclusion Criteria:\n%% ...\nExclusion Criteria:\n%% ..."
    });

    const createGroupCharacteristicValues = (markdownList) => {
        let markdownListSplit = markdownList?.split("Exclusion Criteria:");
        let inclusionList = markdownListSplit[0];
        let exclusionList = markdownListSplit[1];
        let inclusionListSplit = inclusionList?.split("%% ");
        let exclusionListSplit = exclusionList?.split("%% ");
        let groupCharacteristicValue = [];
        if (inclusionListSplit?.length > 1) {
            for (let index in inclusionListSplit) {
                if (index > 0) {
                    groupCharacteristicValue.push({
                        "exclude": false,
                        "description": inclusionListSplit[index]
                    });
                }
            }
        }
        if (exclusionListSplit?.length > 1) {
            for (let index in exclusionListSplit) {
                if (index > 0) {
                    groupCharacteristicValue.push({
                        "exclude": true,
                        "description": exclusionListSplit[index]
                    });
                }
            }
        }
        setGroupCharacteristicState(groupCharacteristicValue);
    }

    return <div>
        <p>Keep the "Inclusion Criteria:" and "Exclusion Criteria:" headings, enter each criterion preceded by "%% ", and delete "%% ..." if not used.</p>
        <MarkdownEntry elementName="markdown" fieldLabel="Inclusion/Exclusion Criteria"
            startingValue={criteriaListState.markdown} setResourceState={setCriteriaListState} />
        <Button className="formButton" style={{ color: "#000000" }}
            content="Create Group.characteristic starter values"
            onClick={() => { createGroupCharacteristicValues(criteriaListState.markdown); }} />
    </div>
}

export default GroupCriteriaStarter;